import { EntityNode } from "./EntityNode";
import { GameObjectManager } from "../GameObjectManager";
import { SketchBlockNode } from "../Nodes/SketchBlockNode";
import { Utils } from "../../utils/Utils";
import { ResizeNode } from "../Nodes/ResizeNode";
import { RotationNode } from "../Nodes/RotationNode";
import { DimensionNode } from "../Nodes/DimensionNode";
import { Plan2DConstantes } from "../PlanManager";
import { CocosConstants } from "../../../../constants";
import { PlanManager } from "../PlanManager";
import { ArrangementObject, ComponentConstants, Events, eventsManager, RendererTopView } from "@rhinov/savane-js";
import { resetUrl } from "@rhinov/asset-manager-service";

declare var cc: any;

export class ArrangementNode extends EntityNode {

    override savaneEntity: ArrangementObject = null!;

    constructor(arrangement: ArrangementObject) {
        super(arrangement);

        this.LINE_WIDTH = 2.0;
        this.savaneEntity = arrangement;

        this._sprite = null;
        this.arrangement = this.savaneEntity;
        this.myAngle = 0;
        //this.setName('Arrangement' + arrangement.id);
        var cocosLength = this.arrangement.realWidth / 10;
        var cocosWidth = this.arrangement.realLength / 10;

        // Clamp the display to be minimum 1px width and height
        if (cocosLength < 1) {
            cocosLength = 1;
        }
        if (cocosWidth < 1) {
            cocosWidth = 1;
        }

        this._sketch = new SketchBlockNode(arrangement);
        this.addChild(this._sketch, -1);
        this._sketch.redraw();

        this.sketchMode = CocosConstants.sketchMode || arrangement.getComponent(ComponentConstants.ComponentType.RendererTopView) === null; // If set to  true the node will display a sketch for that item

        this.layerColor = null;

        this._sketch.setVisible(true);

        this._sprite = new cc.Sprite();
        this._sprite.setVisible(false);
        this._sprite.setScaleX(CocosConstants.SpriteRatio);
        this._sprite.setScaleY(CocosConstants.SpriteRatio);

        this.loadSprite(true);

        this.setPosition(GameObjectManager.convertToCocosCoord(this.arrangement.transform.localPosition));
        this.setRotation(this.arrangement.transform.localZRotation);

        //layer
        this.layerColor = new cc.color(200, 200, 0, 255);

        //DEBUG FOR ZONES
        //for(var i = 0; i < this.arrangement.children.length; i++) {
        //    var zone = this.arrangement.children[i];
        //    var min = GameObjectManager.convertToCocosCoord(zone.transform.localPosition);
        //    min.x -=  (zone.length * 0.5)/10;
        //    min.y -=  (zone.width * 0.5)/10;
        //    var max = GameObjectManager.convertToCocosCoord(zone.transform.localPosition);
        //    max.x +=  (zone.length * 0.5)/10;
        //    max.y +=  (zone.width * 0.5)/10;
        //    this.drawRect(min, max,new cc.color(255, 255, 255, 50));
        //}

        //Bounding box layer
        this.layer = new cc.DrawNode();
        this.layer.setName('ArrangementLayer');
        this.layer.setAnchorPoint(new cc.p(0.5, 0.5));
        this.addChild(this.layer, 8);
        this.layer.setPosition(cc.p(0, 0));
        this.layer.drawRect(cc.p(-cocosWidth / 2, -cocosLength / 2), cc.p(cocosWidth / 2, cocosLength / 2), null, this.LINE_WIDTH, this.layerColor);
        this.layer.setVisible(false);

        //---ROTATION BUTTON
        this.rotateSprite = new RotationNode(this.arrangement);
        this.addChild(this.rotateSprite, 8);

        if (this.arrangement.stretchability) {
            if ((this.arrangement.stretchability.x !== undefined && this.arrangement.stretchability.x.isStretchable) ||
                (this.arrangement.stretchability.y !== undefined && this.arrangement.stretchability.y.isStretchable)) {
                this.resizeMenu = new ResizeNode(this.arrangement as any, undefined as any, undefined as any);
                this.addChild(this.resizeMenu, 8);
            }
        }

        //Menu var
        this.menuVisible = false;
        //TEMPORARY DISPLAY OF Angle
        //Triangle for angle
        var startPoint = cc.p(-(this.arrangement.length / 10) * 0.5, -(this.arrangement.width / 10) * 0.5);
        var endPoint = cc.p((this.arrangement.length / 10) * 0.5, -(this.arrangement.width / 10) * 0.5);
        if (this.arrangement.objectTypeConfig) {
            if (this.arrangement.objectTypeConfig.angleDirection === "right") {
                var nextP = new cc.p(startPoint.x + (endPoint.x - startPoint.x) * 0.25, startPoint.y + (endPoint.y - startPoint.y) * 0.25);
                var lastP = new cc.p(startPoint.x - (endPoint.y - startPoint.y) * 0.25, startPoint.y + (endPoint.x - startPoint.x) * 0.25);
                this.drawPoly([new cc.p(startPoint.x, startPoint.y), nextP, lastP]
                    , this.outlineColor, 2, this.outlineColor);
            } else if (this.arrangement.objectTypeConfig.angleDirection === "left") {
                var nextP = new cc.p(endPoint.x + (startPoint.x - endPoint.x) * 0.25, endPoint.y - (startPoint.y - endPoint.y) * 0.25);
                var lastP = new cc.p(endPoint.x - (startPoint.y - endPoint.y) * 0.25, endPoint.y - (startPoint.x - endPoint.x) * 0.25);
                this.drawPoly([new cc.p(endPoint.x, endPoint.y), nextP, lastP]
                    , this.outlineColor, 2, this.outlineColor);
            }
        }

        this.createDimensions();

        this._isValid = true;

        // In order to redraw the object only when needed
        this.needRedraw = true;

        // Set arrangement visibility depending on hide/display arrangement parameter
        this.setVisible(!PlanManager.getInstance()._hideArrangements);

        this.update(undefined);

        this.hideArrangement = eventsManager.instance.addListener(Events.HIDE_ARRANGEMENTS, (_event: any) => {
            if (this.savaneEntity.isGhost())
                return;

            this.needRedraw = true;
            this.setVisible(!PlanManager.getInstance()._hideArrangements);

            if (this.resizeMenu !== undefined) {
                this.resizeMenu.setVisible(this._isSelected);
            }
            if (this._sketch !== null) {
                this._sketch.setVisible(this.sketchMode);
            }
            if (this._sprite != null) {
                this._sprite.setVisible(!this.sketchMode);
            }
        });
    }

    loadSprite(addChild: boolean) {
        var cocosLength = this.arrangement.realWidth / 10;
        var cocosWidth = this.arrangement.realLength / 10;

        // Clamp the display to be minimum 1px width and height
        if (cocosLength < 1) {
            cocosLength = 1;
        }
        if (cocosWidth < 1) {
            cocosWidth = 1;
        }

        var interval = setInterval(() => {
            if (!this._sprite.textureLoaded()) {
                return;
            }

            clearInterval(interval);
            var scaleX = cocosWidth / this._sprite.texture.width;
            var scaleY = cocosLength / this._sprite.texture.height;
            if (this.savaneEntity.symmetry === true) {
                scaleX = -scaleX;
            }
            this._sprite.setScaleX(scaleX);
            this._sprite.setScaleY(scaleY);

            this.needRedraw = true;
            this._sketch.setVisible(this.sketchMode);
            this._sprite.setVisible(!this.sketchMode);
            if (addChild) {
                this.addChild(this._sprite, -1);
            }
        }, 200);

        var comp = this.savaneEntity.getComponent(ComponentConstants.ComponentType.RendererTopView) as RendererTopView;

        if (comp) {
            //Set url to sprite
            this._sprite.setTexture(resetUrl(this.savaneEntity, comp.urlTopview));
        }
    }

    setForceDimensions(add: boolean) {
        if (add) {
            if (!this.dim1) {
                this.dim1 = new DimensionNode(undefined);
                this.dim1.setName('arrangementObjectDimension1');
                this.dim1.setTag(this.arrangement.id);
                this.dim1.setVisible(false);
                this.addChild(this.dim1, 8);
            }

            if (!this.dim2) {
                this.dim2 = new DimensionNode(undefined);
                this.dim1.setName('arrangementObjectDimension2');
                this.dim2.setTag(this.arrangement.id);
                this.dim2.setVisible(false);
                this.addChild(this.dim2, 8);
            }
        }
        else {
            this.deleteDimensions();
        }
    }

    addStretchability(add: boolean) {
        if (add) {
            this.resizeMenu = new ResizeNode(this.arrangement as any, undefined as any, undefined as any);
            this.addChild(this.resizeMenu, 8);
            this.createDimensions();
        }
        else {
            this.removeChild(this.resizeMenu);
            this.resizeMenu = undefined;
            this.deleteDimensions();
        }
    }

    // Return the sprite width
    getWidth(): number {
        return this._sprite.width;
    }

    // Return the sprite height
    getHeight(): number {
        return this._sprite.height;
    }

    updateDimensionNode(node: any, begin: any, end: any, normal: any, dist: number) {
        var cote_begin = new cc.p(begin.x + dist * normal.x, begin.y + dist * normal.y);
        var cote_end = new cc.p(end.x + dist * normal.x, end.y + dist * normal.y);
        var cote_pos = new cc.p((cote_begin.x + cote_end.x) / 2, (cote_begin.y + cote_end.y) / 2);
        //var middleP = new cc.p(begin.x + (end.x-begin.x)*0.5,begin.y + (end.y-begin.y)*0.5);
        node.setPosition(cote_pos);
        var calcDist = Math.sqrt((end.x - begin.x) * (end.x - begin.x) + (end.y - begin.y) * (end.y - begin.y));
        node.setDimensionValue(calcDist, PlanManager.getInstance().getZoomScale());

        var angle = Math.atan2(end.x - begin.x, end.y - begin.y);
        var cocosAngle = (angle + Math.PI * 0.5) * 180 / Math.PI;
        if (cocosAngle < -90.0)
            cocosAngle += 180;
        if (cocosAngle >= 90.0)
            cocosAngle -= 180;

        var parentAngle = (this.savaneEntity.angle * 180) / Math.PI;
        if (parentAngle < -90.0)
            cocosAngle += 180;
        if (parentAngle > 90.0)
            cocosAngle -= 180;

        node.setRotation(cocosAngle);
    }

    updateDimensions() {
        if (this.dim1) {
            var norm1 = new cc.p(0, -1);
            this.updateDimensionNode(this.dim1, new cc.p((this.savaneEntity.realLength / 2) / 10, -(this.savaneEntity.realWidth / 2) / 10), new cc.p(-(this.savaneEntity.realLength / 2) / 10, -(this.savaneEntity.realWidth / 2) / 10), norm1, Utils.DIMENSION_DIST * 1.5);
        }

        if (this.dim2) {
            var norm2 = new cc.p(1, 0);
            this.updateDimensionNode(this.dim2, new cc.p((this.savaneEntity.realLength / 2) / 10, -(this.savaneEntity.realWidth / 2) / 10), new cc.p((this.savaneEntity.realLength / 2) / 10, (this.savaneEntity.realWidth / 2) / 10), norm2, Utils.DIMENSION_DIST * 1.5);
        }
    }

    createDimensions() {
        if (this.arrangement.stretchability) {
            if (this.arrangement.stretchability.x !== undefined && this.arrangement.stretchability.x.isStretchable) {
                if (!this.dim1) {
                    this.dim1 = new DimensionNode(undefined);
                    this.dim1.setName('arrangementObjectDimension1');
                    this.dim1.setTag(this.arrangement.id);
                    this.dim1.setVisible(false);
                    this.addChild(this.dim1, 8);
                }
            }

            if (this.arrangement.stretchability.y !== undefined && this.arrangement.stretchability.y.isStretchable) {
                if (!this.dim2) {
                    this.dim2 = new DimensionNode(undefined);
                    this.dim1.setName('arrangementObjectDimension2');
                    this.dim2.setTag(this.arrangement.id);
                    this.dim2.setVisible(false);
                    this.addChild(this.dim2, 8);
                }
            }
        }
    }

    deleteDimensions() {
        if (!this.arrangement.stretchability || !this.arrangement.stretchability.x || !this.arrangement.stretchability.x.isStretchable) {
            if (this.dim1 !== undefined) {
                this.removeChild(this.dim1);
                this.dim1 = undefined;
            }
        }

        if (!this.arrangement.stretchability || !this.arrangement.stretchability.y || !this.arrangement.stretchability.y.isStretchable) {
            if (this.dim2 !== undefined) {
                this.removeChild(this.dim2);
                this.dim2 = undefined;
            }
        }
    }

    updateSprite() {
        // New code
        this.removeChild(this._sprite);

        this._sprite = new cc.Sprite();
        this._sprite.setVisible(false);
        this._sprite.setScaleX(CocosConstants.SpriteRatio);
        this._sprite.setScaleY(CocosConstants.SpriteRatio);

        this.loadSprite(true);
        // End new code

        this._sketch.redraw();
    }

    update(dt: any) {
        if (this.needRedraw || this._isSelected || this._isHovered || !this._isValid) {
            super.update(dt);

            if (this._sprite) {
                var scaleX = this.savaneEntity.realLength / this._sprite.width / 10;
                var scaleY = this.savaneEntity.realWidth / this._sprite.height / 10;
                if (this.arrangement.symmetry === true) {
                    scaleX = -scaleX;
                }
                this._sprite.setScale(scaleX, scaleY);
            }

            if (this.savaneEntity.isGhost()) {
                this.needRedraw = false;
                return;
            }
            this.recomputeMenu();
            this._sketch.update();
            this._sketch.redraw();

            if (this.resizeMenu !== undefined) {
                this.resizeMenu.setVisible(this._isSelected);
                this.resizeMenu.update();
            }

            this.updateDimensions();

            if (this.dim1) {
                this.dim1.setVisible(this._isSelected);
                this.dim1.update();
            }

            if (this.dim2) {
                this.dim2.setVisible(this._isSelected);
                this.dim2.update();
            }

            if (this._isSelected) {
                if (!this.rotateSprite.isVisible()) {
                    this.addMenu();
                }
            } else {
                if (this.rotateSprite.isVisible()) {
                    this.deleteMenu();
                }
            }

            this.needRedraw = false;
        }
    }

    toResize(pos: any) {
        if (this.resizeMenu !== undefined) {
            return this.resizeMenu.toResize(pos);
        }
        return false;
    }

    getRotationZ() {
        return this.myAngle;
    }

    setValidity(isValid: boolean) {
        if (this._isValid !== isValid) {
            this.needRedraw = true;
        }
        this._isValid = isValid;

        if (this._sprite !== null) {
            if (!isValid) {
                this._sprite.setColor(Plan2DConstantes.arrangementvec4NotValid);
            }
            else {
                if (this.menuVisible) {
                    this._sprite.setColor(Plan2DConstantes.arrangementvec4Selected);
                }
                else {
                    this._sprite.setColor(Plan2DConstantes.arrangementvec4Valid);
                }
            }
        }
    }

    setHovered(val: boolean) {
        var swip = false;

        if (this._isHovered !== val) {
            this.needRedraw = true;
            swip = true;
        }

        super.setHovered(val);

        if (swip) {
            if (this._isHovered) {
                if (this._sprite !== null) {
                    this._sprite.setColor(Plan2DConstantes.arrangementvec4Hover);
                }
            }
            else {
                if (this._sprite !== null) {
                    if (this.menuVisible) {
                        this._sprite.setColor(Plan2DConstantes.arrangementvec4Selected);
                    }
                    else {
                        this._sprite.setColor(Plan2DConstantes.arrangementvec4Valid);
                    }
                }
            }
        }
    }

    /**
    * Select node and children
    **/
    setSelected(value: boolean) {
        if (this._isSelected !== value) {
            this.needRedraw = true;
        }

        super.setSelected(value);
    }

    addLayer() {
        this.layer.setVisible(true);
    }

    deleteLayer() {
        this.layer.setVisible(false);
    }

    addMenu() {
        this.menuVisible = true;
        this.LINE_WIDTH = 4.0;
        if (this._sprite !== null) {
            this._sprite.setColor(Plan2DConstantes.arrangementvec4Selected);
        }
        this.rotateSprite.setVisible(true);
    }

    deleteMenu() {
        this.menuVisible = false;
        this.LINE_WIDTH = 2.0;
        this.rotateSprite.setVisible(false);
        if (this._sprite !== null) {
            this._sprite.setColor(Plan2DConstantes.arrangementvec4Valid);
        }
    }

    recomputeMenu() {
        this.rotateSprite.update();
        var cocosLength = this.arrangement.width / 10;
        var cocosWidth = this.arrangement.length / 10;
        // Clamp the display to be minimum 1px width and height
        if (cocosLength < 1) {
            cocosLength = 1;
        }
        if (cocosWidth < 1) {
            cocosWidth = 1;
        }
        this.layer.clear();

        this.layer.drawRect(cc.p(-cocosWidth / 2, -cocosLength / 2), cc.p(cocosWidth / 2, cocosLength / 2), null, this.LINE_WIDTH, this.layerColor);
    }

    toRotate(position: any) {
        return this.rotateSprite.toRotate(position);
    }

    onEnter() {
        super.onEnter();
        //Listener for hover enter
        this.hoverListener = eventsManager.instance.addListener(Events.ENTITY_HOVER, (datas: any) => {
            if (this.arrangement._id === datas.getUserData().id) {
                //Change hovered state
                this.setHovered(datas.getUserData().value);
            }
        });

        this.finishesUpdateListener = eventsManager.instance.addListener(Events.FINISHES_DONE, () => {
            this._sketch.redraw();
        });
        this.sketchModeListerner = eventsManager.instance.addListener(Events.TOGGLE_SKETCH_MODE, (datas: any) => {
            if (this.arrangement.getComponent(ComponentConstants.ComponentType.RendererTopView) === null) {
                return;
            }
            this.sketchMode = datas.getUserData() === null ? !this.sketchMode : datas.getUserData();
            this._sketch.setVisible(this.sketchMode);
            if (this._sprite !== null) {
                this._sprite.setVisible(!this.sketchMode);
            }
        });

    }
    //Not very good ! Only work in canvas :/
    getImgHtmlElement(): HTMLElement {
        return this._sprite._texture._htmlElementObj;
    }

    onExit() {
        super.onExit();
        eventsManager.instance.removeListener(this.sketchModeListerner);
        eventsManager.instance.removeListener(this.hoverListener);
        eventsManager.instance.removeListener(this.finishesUpdateListener);
        eventsManager.instance.removeListener(this.hideArrangement);
    }
}